// import {filter, forEach, without, sample} from 'lodash'

export default {
    players: state => {
        return state.gameState.settings.players;
    },
    playersPreset: state => {
        return state.playersPreset;
    },
    currentPlayer: state => {
        return state.gameState.currentPlayer;
    },
    wordsSet: state => {
        return state.gameState.currentWordsSet
    },
    wordsChunksSets: state => {
        return state.chunks
    },
    wordsChunksSelected: state => {
        return state.gameState.currentWordChunks
    },
    currentTimer: state => {
        return state.gameState.settings.time
    },
    countForWin: state => {
        return state.gameState.settings.countForWin
    },


    winner: state => {
        return state.gameState.winner
    },
    gameScore: state => {
        return state.gameState.winner
    }
    ,
    currentGameState: state => {
        return state.currentGameState
    }


}
